/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, IdeaLottie, Icon } from '@components/atoms'

import { useAppSelector, MenuType } from '@redux/index'
import { blueGrey } from '@mui/material/colors'

const AdminHomePage = () => {
	// redux state
	const systemName: string = useAppSelector(state => state.config.systemName)
	const adminMenu: MenuType[] = useAppSelector(state => state.admin.menu)

	// variables
	const title = `${systemName} Admin`

	const ContentText = ({ menu }: { menu: MenuType }) => {
		return (
			<View className="contentTextView">
				{menu.id === 'adminAccessControl' ? (
					<>
						<Text category="p2">주식회사 넥센의 모든 사원정보를 확인할 수 있습니다.</Text>
						<Text category="p2">사원들의 소중한 정보를 지켜주세요.</Text>
						<Text category="p2">우리는 단 하나의 정보도 외부로 흘러가지 않게</Text>
						<Text category="p2">안전한 정보보호를 이루는 정보전략팀입니다.</Text>
					</>
				) : menu.id === 'adminMenu' ? (
					<>
						<Text category="p2">부서의 정보를 확인하고 싶다면</Text>
						<Text category="p2">이 곳에서 모든 부서정보를 확인할 수 있습니다.</Text>
						<Text category="p2">단, 생성, 수정, 삭제는 그룹웨어서 가능합니다.</Text>
					</>
				) : menu.id === 'adminIssueManagement' ? (
					<>
						<Text category="p2">IAM이란?</Text>
						<Text category="p2">각 계정의 접근권한 관리를 의미합니다.</Text>
						<Text category="p2">특정 시스템에 사원의 접근 권한을 관리하고 싶다면</Text>
						<Text category="p2">이 곳에서 관리할 수 있습니다.</Text>
						<Text category="p2">그러나 권한부여는 신중하게 해주시기 바랍니다.</Text>
					</>
				) : (
					''
				)}
			</View>
		)
	}

	return (
		<View css={style}>
			<View className="contentTopView">
				<View className="contentTitleView">
					<Text category="h1" style={{ fontFamily: 'audiowideRegular' }}>
						{title}
					</Text>
					<Text category="h5">개인정보는 안전하게 권한부여는 신중하게</Text>
				</View>
				<View className="contentImageView">
					<View className="contentImageInnerView">
						<IdeaLottie />
					</View>
				</View>
				<View className="contentImageBackgroundView" />
				<View className="contentImageBackgroundView2" />
			</View>

			<View className="contentOuterView">
				<View className="contentInnerView">
					<View className="menuListView">
						{adminMenu.map(aMenu => {
							return (
								<View key={aMenu.id} className="menuView">
									<View className="menuInnerView">
										<View className="IconView">
											<Icon className="menuIcon" name={aMenu.icon ?? ''} />
										</View>
										<View className="textView">
											<Text category="s1" className="menuTitle" i18n={aMenu.i18n}>
												{aMenu.name}
											</Text>
											<ContentText menu={aMenu} />
										</View>
									</View>
								</View>
							)
						})}
					</View>
				</View>
			</View>
		</View>
	)
}

export default AdminHomePage

const style = css({
	'.contentTopView': {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '20rem',
		background: blueGrey[800],
		overflow: 'hidden',

		'.contentTitleView': {
			position: 'absolute',
			left: '10rem',
			textAlign: 'left',
			color: '#fff',

			'.text.h1': {
				fontSize: '40px',
				margin: 0,
				marginBottom: '1rem',
			},
		},

		'.contentImageView': {
			position: 'absolute',
			width: 'fit-content',
			height: 'fit-content',
			right: '10rem',

			'.contentImageInnerView': {
				position: 'relative',
				zIndex: 3,
			},
		},

		'.contentImageBackgroundView': {
			position: 'absolute',
			zIndex: 1,
			width: '40rem',
			height: '25rem',
			top: 0,
			right: 0,
			borderRadius: '40% 0 0 70%',
			background: '#FFF',
			opacity: 0.2,
		},

		'.contentImageBackgroundView2': {
			position: 'absolute',
			zIndex: 1,
			width: '60rem',
			height: '25rem',
			top: 0,
			right: 0,
			borderRadius: '40% 0 0 70%',
			background: '#FFF',
			opacity: 0.1,
		},
	},

	'.contentOuterView': {
		position: 'relative',
		width: '100%',
		height: '100%',
		padding: '2rem',

		'.contentInnerView': {
			width: '100%',
			height: 'fit-content',
			minHeight: 'calc(100vh - 27rem)',

			'.menuListView': {
				display: 'flex',
				justifyContent: 'center',
				width: '100%',
				height: '100%',
				minHeight: 'calc(100vh - 27rem)',

				'.menuView': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '25%',
					height: '100%',
					padding: '0 0.5rem',

					'.menuInnerView': {
						position: 'relative',
						width: '100%',
						height: '100%',
						minHeight: 'calc(100vh - 27rem)',
						background: '#FFF',
						border: '1px solid',
						borderColor: blueGrey['A400'],
						borderRadius: '10px',
						overflow: 'hidden',

						'.IconView': {
							width: '100%',
							background: blueGrey['A400'],

							'.menuIcon': {
								fontSize: '60px',
								color: '#FFF',
							},
						},
						'.textView': {
							padding: '0 0.5rem',
							textAlign: 'left',

							'.menuTitle': {},
							'.contentTextView': {
								wordBreak: 'keep-all',
							},
						},
					},
				},
			},
		},
	},
})
